import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';

import {ACTION, STATUS} from '../constant';

@Injectable()
export class CurrentUserResolve implements Resolve<Observable<any>> {

  currentUser$: Observable<any>;

  constructor(private store: Store<any>) {
    this.currentUser$ = this.store.select('PERSON_REDUCER');
  }

  resolve(route: ActivatedRouteSnapshot): any {
    this.store.dispatch({
      type: ACTION.LOAD_CURRENT_USER,
      payload: {}
    });

    return this.currentUser$
      .filter(state => state.status === STATUS.COMPLETED)
      .map(state => state.user)
      .first();
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/shared/resolves/current-user.resolve.ts